import Controller from '@ember/controller';
import { inject as service } from '@ember/service';
import {
  State,
  addManagerButtonClickAction,
  addOwnerButtonClickAction,
  continueButtonClickAction,
  editIndividualClickAction,
  closeDialogAction,
  individualSubmitRequestAction,
  deleteIndividualSubmitRequestAction,
} from '@banking/ui/workflows/onboarding-ci';
import {
  requiredManagersPresent,
  requiredOwnersPresent,
} from '@banking/ui/workflows/onboarding-ci/state';
import {
  Individual,
  ownerIndividuals,
} from '@banking/api/models/onboarding/individual';
import KybWorkflow from '@banking/savings-onboarding-app/services/kyb-workflow';
import { backButtonClickAction } from '@banking/ui/workflows/onboarding-kyb/action';
import { action } from '@ember/object';

export default class ControllingIndividuals extends Controller {
  @service kybWorkflow!: KybWorkflow;

  get dialogIsEditing(): boolean {
    return (
      this.kybWorkflow.state.ciState.dialog?.screen ===
        State.DialogScreen.EditManager ||
      this.kybWorkflow.state.ciState.dialog?.screen ===
        State.DialogScreen.EditOwner
    );
  }

  get dialogIsForManager(): boolean {
    return (
      this.kybWorkflow.state.ciState.dialog?.screen ===
        State.DialogScreen.AddManager ||
      this.kybWorkflow.state.ciState.dialog?.screen ===
        State.DialogScreen.EditManager
    );
  }

  get canAddSignificantOwners(): boolean {
    return (
      ownerIndividuals(this.kybWorkflow.state.ciState.individuals).length < 4
    );
  }

  get canManagerBeSignificantOwner(): boolean {
    const numberOfOwners = ownerIndividuals(
      this.kybWorkflow.state.ciState.individuals
    ).length;
    const isSignificantOwner =
      this.kybWorkflow.state.ciState.dialog?.individual?.isSignificantOwner ??
      false;
    return (
      this.dialogIsForManager && (numberOfOwners < 4 || isSignificantOwner)
    );
  }

  @action requiredManagersPresent() {
    return requiredManagersPresent(this.kybWorkflow.state.ciState);
  }

  @action requiredOwnersPresent() {
    return requiredOwnersPresent(this.kybWorkflow.state.ciState);
  }

  @action editIndividualButtonClick(individual: Individual) {
    this.kybWorkflow.emit(editIndividualClickAction(individual.id));
  }

  @action addManagerButtonClick() {
    this.kybWorkflow.emit(addManagerButtonClickAction());
  }

  @action addOwnerButtonClick() {
    this.kybWorkflow.emit(addOwnerButtonClickAction());
  }

  @action continue() {
    this.kybWorkflow.emit(continueButtonClickAction());
  }

  @action goBack() {
    this.kybWorkflow.emit(backButtonClickAction());
  }

  @action closeDialog() {
    this.kybWorkflow.emit(closeDialogAction());
  }

  @action saveIndividual(individual: Individual) {
    this.kybWorkflow.emit(individualSubmitRequestAction(individual));
  }

  @action deleteIndividual() {
    if (!this.kybWorkflow.state.ciState.dialog?.individual.id) {
      throw new Error('tried to emit a delete action with no individual');
    }

    this.kybWorkflow.emit(
      deleteIndividualSubmitRequestAction(
        this.kybWorkflow.state.ciState.dialog?.individual.id
      )
    );
  }
}
